<template>
  <div v-if="checkpoint" class="cp_info_block_holder row">
    <div v-if="this.checkpoint.media.length > 0">
      <img style="max-width: 100%; padding: 15px; border-radius: 30px;" :src=this.media>
    </div>
    <div class="info_block border_radius-left col-xs-6">
      <span class="info_block_text" id="cpdist">{{cpdist()}}</span><br><span class="info_block_text_small">Distance</span>
    </div>
    <div class="info_block border_radius-right col-xs-6">
      <span class="info_block_text" id="cpalt">{{cpalt()}}</span><br><span class="info_block_text_small">Altitude</span>
    </div>
  </div>
</template>
<style>
</style>
<script>
import { mapGetters } from 'vuex'

export default{
  data: function () {
    return {
      cpid: null
    }
  },
  computed: {
    ...mapGetters({
      checkpoints: 'checkpoints',
      focusedCP: 'focusedCP'
    }),
    checkpoint () {
      return this.checkpoints[this.$route.params.id]
    },
    media() {
       return 'https://sportrax.imgix.net/' + this.checkpoint.media[0].file_name
    }
  },
  created () {
    this.$store.dispatch('focusCP', this.$route.params.id)
  },
  destroyed(){
    this.$store.dispatch('focusCP', '')
  },
  methods: {
    cpdist: function () {
      return (this.checkpoint.point.distance / 1000.0).toFixed(2) + ' km'
    },
    cpalt: function () {
      return Number(this.checkpoint.point.elevation).toFixed(0) + ' m'
    },
    cpasc: function () {
      // return Number(this.focusedCP.altgain).toFixed(0) + ' m'
    },
    cpdesc: function () {
      // return Number(this.focusedCP.altlost).toFixed(0) + ' m'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/checkpoint/checkpoint.vue